import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  container: {
    color: '#FFF',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(6),
    marginLeft: 'auto',
    marginRight: 'auto',
    padding: theme.spacing(0, 4),
    maxWidth: 'calc(100% - 12px)',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0, 2),
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0, 2),
      marginBottom: theme.spacing(4),
    },
  },
  center: {
    textAlign: 'center',
  },
}))
